import React, { Component } from "react";
import themeLarge from "../ThemeLarge";
import ImageReplaceModal from "./ImageReplaceModal";

class BlogMetadataForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAdvanced: false, // slug + excerpt are hidden by default
      modalOpenIndex: null,
    };
  }

  toggleAdvanced = () => {
    this.setState((prev) => ({ showAdvanced: !prev.showAdvanced }));
  };

  openModal = (index) => {
    this.setState({ modalOpenIndex: index });
  };

  closeModal = () => {
    this.setState({ modalOpenIndex: null });
  };

  render() {
    const {
      title,
      slug,
      photos,
      onPhotoReplace,
      excerpt,
      onTitleChange,
      onSlugChange,
      onExcerptChange,
    } = this.props;

    const { showAdvanced } = this.state;

    return (
      <>
        {/* Blog Title */}
        <div className="form-group mb-3">
          <label
            htmlFor="title"
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.h4,
            }}
          >
            Title
          </label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={title}
            onChange={onTitleChange}
            placeholder="Enter the blog title"
            required
            style={{
              fontFamily: "Kumbh Sans",
              fontSize: themeLarge.fontSize.body,
            }}
          />
        </div>

        {/* Toggle Button */}
        <div
          className="d-flex align-items-center justify-content-between mb-2"
          style={{
            cursor: "pointer",
            fontWeight: "500",
            userSelect: "none",
            color: themeLarge.colors.text,
            fontFamily: "Kumbh Sans",
            fontSize: themeLarge.fontSize.small,
          }}
          onClick={this.toggleAdvanced}
        >
          <span>Show Advanced</span>
          <span>{showAdvanced ? "▲" : "▼"}</span>
        </div>

        {/* Conditionally rendered slug and excerpt */}
        {showAdvanced && (
          <>
            {onSlugChange && (
              <div className="form-group mb-3">
                <label
                  htmlFor="slug"
                  style={{
                    fontFamily: "Kumbh Sans",
                    fontSize: themeLarge.fontSize.body,
                  }}
                >
                  Slug
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="slug"
                  name="slug"
                  value={slug}
                  placeholder="custom-blog-slug"
                  disabled
                />
              </div>
            )}
            {onExcerptChange && (
              <div className="form-group mb-3">
                <label
                  htmlFor="excerpt"
                  style={{
                    fontFamily: "Kumbh Sans",
                    fontSize: themeLarge.fontSize.body,
                  }}
                >
                  Excerpt
                </label>
                <textarea
                  className="form-control"
                  id="excerpt"
                  rows="3"
                  value={excerpt}
                  onChange={onExcerptChange}
                  placeholder="Short summary of the blog..."
                ></textarea>
              </div>
            )}

            {photos && photos.length > 0 && (
              <div className="row">
                <label
                  htmlFor="photos"
                  style={{
                    fontFamily: "Kumbh Sans",
                    fontSize: themeLarge.fontSize.body,
                    paddingBottom: "5px",
                  }}
                >
                  Photos
                </label>
                <table
                  className="table table-sm table-bordered"
                  style={{
                    width: "500px",
                    marginLeft: "10px",
                  }}
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>URL</th>
                      <th style={{ width: "120px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {photos.map((url, index) => (
                      <tr
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() => this.openModal(index)}
                      >
                        <td>{index}</td>
                        <td style={{ wordBreak: "break-all" }}>
                          {" "}
                          [Image {index}]
                        </td>
                        <td>
                          <button
                            className="btn btn-md btn-outline-success me-2"
                            onClick={(e) => {
                              e.stopPropagation();
                              this.openModal(index);
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {/* React modal preview */}
                {this.state.modalOpenIndex !== null && (
                  <ImageReplaceModal
                    imageUrl={photos[this.state.modalOpenIndex]}
                    index={this.state.modalOpenIndex}
                    onPhotoReplace={onPhotoReplace}
                    onClose={this.closeModal}
                  />
                )}
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

export default BlogMetadataForm;
